
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recommendation-engine/[slug]/[question]",
      function () {
        return require("private-next-pages/recommendation-engine/[slug]/[question].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recommendation-engine/[slug]/[question]"])
      });
    }
  